import { useContext } from 'react';

import { Card, CardContent, CardActions, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ArchiveOutlined as Archive, DeleteOutlineOutlined as Delete} from '@mui/icons-material';
import { DataContext } from '../../Context API/DataProvider';

const StyledCard = styled(Card)`
    border: 1px solid #e0e0e0;  
    border-radius: 8px;
    width: 240px;
    margin: 8px;
    box-shadow: none;
`

const Note = ({ note }) => {

    const { notes, setNotes, setAcrchiveNotes, setDeleteNotes } = useContext(DataContext);

    const archiveNote = (note) => {
        const updatedNotes = notes.filter(data => data.id !== note.id);
        setNotes(updatedNotes);
        setAcrchiveNotes(prevArr => [note, ...prevArr]);
    }

    const deleteNote = (note) => {
        const updatedNotes = notes.filter(data => data.id !== note.id);
        setNotes(updatedNotes);
        setDeleteNotes(prevArr => [note, ...prevArr]);
    }

    return (
        <StyledCard>
                <CardContent>
                    <Typography style={{fontWeight: '500',fontFamily: 'Poppins'}}>{note.heading}</Typography>
                    <Typography style={{fontFamily: 'Poppins'}}>{note.text}</Typography>
                </CardContent>
                <CardActions>
                    <Archive 
                        fontSize="small" 
                        style={{ marginLeft: 'auto',cursor: 'pointer' }} 
                        onClick={() => archiveNote(note)}
                    />  
                    <Delete 
                        fontSize="small"
                        onClick={() => deleteNote(note)}
                        style={{cursor: 'pointer' }}
                    />
                </CardActions>
        </StyledCard>
    )
}

export default Note;